__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@sbxapps/sbx-operations-servicescheduling-expertcalendar-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@sbx/sbx-ui-components", "9.10.6", () => (Promise.all([__webpack_require__.e(321), __webpack_require__.e(129), __webpack_require__.e(478), __webpack_require__.e(484), __webpack_require__.e(708), __webpack_require__.e(746), __webpack_require__.e(64), __webpack_require__.e(825), __webpack_require__.e(697)]).then(() => (() => (__webpack_require__(8129))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(373).then(() => (() => (__webpack_require__(3373))))));
			register("moment-timezone", "0.5.47", () => (Promise.all([__webpack_require__.e(302), __webpack_require__.e(708)]).then(() => (() => (__webpack_require__(6302))))));
			register("moment", "2.30.1", () => (Promise.all([__webpack_require__.e(666), __webpack_require__.e(857)]).then(() => (() => (__webpack_require__(9420))))));
			register("react-cookie", "7.2.2", () => (Promise.all([__webpack_require__.e(72), __webpack_require__.e(478)]).then(() => (() => (__webpack_require__(6072))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(144), __webpack_require__.e(478)]).then(() => (() => (__webpack_require__(3144))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(824), __webpack_require__.e(478), __webpack_require__.e(484), __webpack_require__.e(600)]).then(() => (() => (__webpack_require__(9824))))));
			register("react-router-dom", "6.29.0", () => (Promise.all([__webpack_require__.e(429), __webpack_require__.e(478), __webpack_require__.e(484)]).then(() => (() => (__webpack_require__(1429))))));
			register("react-tiny-popover", "8.0.4", () => (Promise.all([__webpack_require__.e(478), __webpack_require__.e(484), __webpack_require__.e(358)]).then(() => (() => (__webpack_require__(358))))));
			register("react-tooltip", "5.28.0", () => (Promise.all([__webpack_require__.e(36), __webpack_require__.e(478), __webpack_require__.e(746)]).then(() => (() => (__webpack_require__(2036))))));
			register("react", "18.3.1", () => (__webpack_require__.e(41).then(() => (() => (__webpack_require__(4041))))));
			register("redux-saga", "1.3.0", () => (Promise.all([__webpack_require__.e(66), __webpack_require__.e(369), __webpack_require__.e(855)]).then(() => (() => (__webpack_require__(4066))))));
			register("redux-thunk", "2.4.2", () => (__webpack_require__.e(74).then(() => (() => (__webpack_require__(6074))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(755).then(() => (() => (__webpack_require__(5755))))));
			register("rrule", "2.8.1", () => (__webpack_require__.e(330).then(() => (() => (__webpack_require__(3949))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(817), __webpack_require__.e(715), __webpack_require__.e(478)]).then(() => (() => (__webpack_require__(2715))))));
			register("styled-components", "5.3.3", () => (Promise.all([__webpack_require__.e(817), __webpack_require__.e(535), __webpack_require__.e(478)]).then(() => (() => (__webpack_require__(3535))))));
			register("uuid", "8.3.2", () => (__webpack_require__.e(412).then(() => (() => (__webpack_require__(5412))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(82).then(() => (() => (__webpack_require__(8082))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(460).then(() => (() => (__webpack_require__(4460))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};